import { render } from "./Piezas.vue?vue&type=template&id=3abe7db4&scoped=true"
import script from "./Piezas.vue?vue&type=script&lang=js"
export * from "./Piezas.vue?vue&type=script&lang=js"

import "./Piezas.vue?vue&type=style&index=0&id=3abe7db4&scoped=true&lang=scss"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3abe7db4"]])

export default __exports__